// カテゴリーから探す — スクロールイン時に画像を 110% → 100%（0.8秒）

(function () {
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function markImageInView(image) {
    if (image.classList.contains('is-in-view')) return;

    void image.offsetWidth;
    image.classList.add('is-in-view');

    if (REDUCED_MOTION) {
      image.classList.add('is-revealed');
      return;
    }

    image.addEventListener(
      'animationend',
      (event) => {
        if (event.animationName !== 'cm-search-category-image-reveal') return;
        image.classList.add('is-revealed');
      },
      { once: true }
    );
  }

  function revealCategoryImages(root = document) {
    const images = root.querySelectorAll('.cm-search-category .cm-category-tile__image');
    if (!images.length) return;

    if (REDUCED_MOTION) {
      images.forEach((image) => markImageInView(image));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          markImageInView(entry.target);
          obs.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -10% 0px',
        threshold: 0,
      }
    );

    images.forEach((image) => {
      if (!image.classList.contains('is-in-view')) {
        observer.observe(image);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => revealCategoryImages());

  document.addEventListener('shopify:section:load', (event) => {
    revealCategoryImages(event.target);
  });
})();
